import React from "react";
import {useTranslation} from "react-i18next";
import {CustomSelectItem, MaterialAddableTool} from "../../../../../../../../models/interfaces";
import {EditorTool} from "../../../../models/enums";

const MEASUREMENT_TYPE_LABEL_KEYS: Record<string, "editor.measurementTypeLabels.count" | "editor.measurementTypeLabels.length" | "editor.measurementTypeLabels.area" | "editor.measurementTypeLabels.topViewWallArea" | "editor.measurementTypeLabels.volume"> = {
	[EditorTool.COUNT]: "editor.measurementTypeLabels.count",
	[EditorTool.LENGTH]: "editor.measurementTypeLabels.length",
	[EditorTool.AREA]: "editor.measurementTypeLabels.area",
	[EditorTool.TOP_VIEW_WALL_AREA]: "editor.measurementTypeLabels.topViewWallArea",
	[EditorTool.VOLUME]: "editor.measurementTypeLabels.volume",
};

type Props = {
	value: MaterialAddableTool | undefined
	onChange: (value: MaterialAddableTool) => void
}

export function MeasurementTypeSelect({value, onChange}: Props) {
	const {t} = useTranslation();

	const items: CustomSelectItem<MaterialAddableTool>[] = [
		EditorTool.COUNT, EditorTool.LENGTH, EditorTool.AREA, EditorTool.TOP_VIEW_WALL_AREA, EditorTool.VOLUME
	].map(type => ({
		label: t(MEASUREMENT_TYPE_LABEL_KEYS[type]) as string,
		value: type as MaterialAddableTool
	}))

	return (
		<select
			value={value}
			onChange={event => {
				onChange(event.target.value as MaterialAddableTool)
			}}
		>
			{items.map(item => (
				<option key={item.value} value={item.value}>
					{item.label}
				</option>
			))}
		</select>
	)
}
